import { helpers } from "vuelidate/lib/validators";

export default extensions =>
  helpers.withParams({ type: "ext", ext: extensions }, files => {
    if (!helpers.req(files)) return false;
    if (!Array.isArray(files)) files = [files];
    const regex = new RegExp(`.(${extensions.join("|")})$`, "i");
    return files.every(file => regex.test(file.name));
  });
